import {html} from "../../admin/script/libs/lit.dist.js";
import {PkLitElement} from "../../admin/script/custom-elements/abstract-element.js";
import style from './pk-corner-ribbon.css.js';

class PkCornerRibbon extends PkLitElement {

    static properties = {
        type: {type: String},
    };

    static styles = [style];

    render() {
        return html`
            <span class="pk-corner-ribbon ${this.type ? `pk-corner-ribbon--${this.type}` : ''}">
                <slot></slot>
            </span>
        `;
    }
}

window.customElements.define('pk-corner-ribbon', PkCornerRibbon);
